import { render, staticRenderFns } from "./SpacesEditorFooter.vue?vue&type=template&id=0b6371b0&scoped=true"
import script from "./SpacesEditorFooter.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorFooter.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorFooter.scss?vue&type=style&index=0&id=0b6371b0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6371b0",
  null
  
)

export default component.exports